// extracted by mini-css-extract-plugin
export default {"menuBlock":"qF-z","title":"rF-z","nav":"sF-z","flexCell":"tF-z","facetLink":"uF-z"};